import { getUser } from 'services/auth'
import { getToken, clearToken } from 'helpers/auth'

async function bootstrapAppData() {
  const token = getToken()
  if (!token) {
    return { user: null }
  }
  try {
    const { data } = await getUser()

    if (!data) {
      return { user: null }
    }
    return {
      user: data,
    }
  } catch (err) {
    console.log(err)
    clearToken()
    return { user: null }
  }
}

export { bootstrapAppData }
